import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import BackButton from '../components/BackButton';
import Icon from '../components/Icon';
import './styles/BookScreen.css';
import vocabulary_A1 from '../data/vocabulary_A1';
import vocabulary_A2 from '../data/vocabulary_A2';
import vocabulary_B1 from '../data/vocabulary_B1';
import vocabulary_B2 from '../data/vocabulary_B2';
import extra_vocabulary from '../data/extra_vocabulary';

const BookScreen = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const chapters = [
    { number: 1, link: 'Finnish_A1', name: 'Finnish A1', vocabulary: vocabulary_A1, icon: 'star',  color: 'var(--color-success)' },
    { number: 2, link: 'Finnish_A2', name: 'Finnish A2', vocabulary: vocabulary_A2, icon: 'book',  color: 'var(--color-vocab)' },
    { number: 3, link: 'Finnish_B1', name: 'Finnish B1', vocabulary: vocabulary_B1, icon: 'chart', color: 'var(--color-writing)' },
    { number: 4, link: 'Finnish_B2', name: 'Finnish B2', vocabulary: vocabulary_B2, icon: 'flame', color: 'var(--color-progress)' },
    { number: 5, link: 'Extra_Vocabulary', name: t('extraVocabulary'), vocabulary: extra_vocabulary, icon: 'bulb', color: 'var(--color-error)' },
  ];

  const handleChapterPress = (chapterNumber) => {
    const selectedChapter = chapters.find((chapter) => chapter.number === chapterNumber);
    navigate(`/vocab-screen/${selectedChapter.link}`, { state: { chapterNumber, selectedChapter } });
  };

  return (
    <div className="container">
      <BackButton to="/vocabulary" label={t('vocabulary')} />
      <h2 className="page-title">{t('chooseBook')}</h2>
      <div className="book-selector">
        {chapters.map((chapter) => (
          <button
            key={chapter.number}
            className="chapter-tile"
            onClick={() => handleChapterPress(chapter.number)}
          >
            <span className="chapter-icon"><Icon name={chapter.icon} size={32} color={chapter.color} /></span>
            <p className="chapterText">{chapter.name}</p>
            <p className="chapter-count">{chapter.vocabulary.length} {t('words')}</p>
          </button>
        ))}
      </div>
    </div>
  );
};

export default BookScreen;
